import { BunnyFace } from '@app/components/ui/bunny';
import LazyImage from '@app/components/ui/lazy-image';
import Passage from '@app/components/ui/passage';
import Reveal from '@app/components/ui/reveal';
import { DiaryEntryDto } from '@app/models/dtos/contentDto';
import { youtubePoster } from '@app/utils/media';
import { formatDiaryDate } from '@app/utils/stringUtils';
import Link from 'next/link';

/** Three most recent entries, as a way in rather than a section of its own. */
export default function DiaryTeaser({ entries }: { entries: DiaryEntryDto[] }) {
    if (entries.length === 0) return null;
    const recent = entries.slice(0, 3);

    return (
        <Passage id="diary" heading="Where I code from">
            <Reveal>
                <p className="t-body text-body">Sometimes I remember to take a photo of where I am working. Here are a few.</p>

                <ul className="mt-7 grid grid-cols-3 gap-3">
                    {recent.map((entry) => (
                        <li key={entry.id}>
                            <Link href="/diary" className="group block" aria-label={`Diary: ${entry.place}, ${formatDiaryDate(entry.date)}`}>
                                <span className="relative block aspect-square w-full overflow-hidden bg-paper">
                                    <LazyImage
                                        src={entry.type === 'photo' ? entry.src : youtubePoster(entry.videoId)}
                                        alt={entry.type === 'photo' ? entry.alt : entry.title}
                                        fill
                                        sizes="(max-width: 640px) 33vw, 210px"
                                        className="object-cover transition-transform duration-500 group-hover:scale-[1.05]"
                                        loaderSize={22}
                                    />
                                </span>
                                <span className="t-script-sm mt-1.5 block leading-tight text-muted transition-colors group-hover:text-accent">{formatDiaryDate(entry.date)}</span>
                            </Link>
                        </li>
                    ))}
                </ul>

                <Link href="/diary" className="group mt-7 inline-flex items-end gap-2">
                    <span className="link t-small">See all with bunny</span>
                    {/* Bunny hops ahead of you toward the diary. */}
                    <BunnyFace size={19} className="transition-transform duration-300 ease-out group-hover:[transform:translate(4px,-5px)]" />
                </Link>
            </Reveal>
        </Passage>
    );
}
